import { StatusInfo } from '@george-labs.com/design-system';
import type { FC } from 'react';

interface Props {
    title: string;
    description?: string;
}

export const SpecificError: FC<Props> = ({ title, description }) => (
    <StatusInfo preferIllustration variant={StatusInfo.VARIANT.ERROR} title={title}>
        {description}
    </StatusInfo>
);
